import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useUser } from './context/UserContext';

import LoginForm from './components/LoginForm';
import LayoutAdmin from './layouts/LayoutAdmin';
import UserTable from './components/Accounts/Users/UserTable';
import ServicesTable from './components/Services/ServicesTable';
import SubscriptionsTable from './components/Subscriptions/SubscriptionsTable';
import OrdersTable from './components/Orders/OrdersTable';
import DashboardAdmin from './components/Dashboard/DashboardAdmin';
import Settings from './components/Settings/Settings';
import Downloads from './components/Downloads/DownloadsTable';
import Credits from './components/Credits/UserCreditsTable';
import EditUserViewPage from './components/Accounts/Users/EditUser';
import PrivateRoute from './routes/PrivateRoute';

// Blog
import BlogList from './components/blog/BlogList';
import BlogForm from './components/blog/BlogForm'; // Reutilizado para crear
import EditBlogPage from './pages/EditBlogPage';   // Wrapper para edición

function App() {
  const { token, isLoading } = useUser();

  if (isLoading) {
    return <div className="text-center mt-12 text-gray-600">Cargando aplicación...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Login */}
        <Route path="/login" element={token ? <Navigate to="/dashboard" /> : <LoginForm />} />

        {/* Rutas protegidas */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <DashboardAdmin />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/clientes"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <UserTable />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/usuarios/:id"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <EditUserViewPage />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <OrdersTable />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/servicios"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <ServicesTable />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/subscriptions"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <SubscriptionsTable />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <Settings />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/downloads"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <Downloads />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/credits"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <Credits />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />

        {/* Blog */}
        <Route
          path="/blog"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <BlogList />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/blog/create"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <BlogForm />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />
        <Route
          path="/blog/edit/:id"
          element={
            <PrivateRoute>
              <LayoutAdmin>
                <EditBlogPage />
              </LayoutAdmin>
            </PrivateRoute>
          }
        />

        {/* Redirección raíz */}
        <Route path="/" element={<Navigate to={token ? '/dashboard' : '/login'} />} />

        {/* Página no encontrada */}
        <Route path="*" element={<p className="text-center mt-8">Página no encontrada</p>} />
      </Routes>
    </Router>
  );
}

export default App;
